module.exports = __webpack_public_path__ + "assets/img/d442b8412397245ca87ba32e06a9a95b.png";